<div class="row d-flex justify-content-center">
    <div class="col-10 col-lg-6 d-flex justify-content-center">
        <form class="row d-flex justify-content-center" [formGroup]="forgotForm">
            <!-- HEADING -->
            <h3 class="col-12 mt-5 mb-4" translate>RECOVERY.TITLE</h3>

            <!-- EMAIL -->
            <div class="col-12">
                <label for="emailInput" translate>FIELDS.EMAIL</label>
                <div class="input-group mb-3">
                    <input type="text" class="form-control" id="emailInput" formControlName="email">
                </div>
            </div>

            <!-- RECOVER BUTTON -->
            <div class="col-12 mb-3">
                <button type="submit" class="btn btn-primary" (click)="recover()" translate>RECOVERY.BUTTON</button>
            </div>

            <!-- ERROR MESSAGES -->
            <div class="col-12 mb-4">
                <!-- EMAIL ERROR -->
                <div *ngIf="forgotForm.controls['email'].invalid && (forgotForm.controls['email'].dirty || forgotForm.controls['email'].touched)" class="text-danger mb-2" translate>
                    ERRORS.INVALID_EMAIL
                </div>

                <!-- SERVER RESPONSE ERROR -->
                <div *ngIf="errorMessage" class="text-danger mb-2" translate>
                    ERRORS.USER_NOT_FOUND
                </div>
            </div>
        </form>
    </div>
</div>